import React from 'react';
import { connect } from 'react-redux';
import * as styles from "../tanks.module.scss";
import TankListView from '../tank/tank_list_view.jsx';


export default class AreaView extends React.Component {
    constructor(props) {
        super(props);
        this.selectTank = this.selectTank.bind(this);
        this.addTank = this.addTank.bind(this);
    }

    selectTank(tank) {
        this.props.selectTankFunction(tank);
    }

    addTank() {
        this.props.addTankFunction(this.props.area.areaId);
    }

    render() {
        return (
            <div className={styles.area_view_container}>
                <div className={styles.area_header}>
                    <div className={styles.area_name}>
                        {this.props.area.areaName}
                    </div>
                    <button className={styles.add_item_button} onClick={this.addTank}></button>
                </div>

                <div className={styles.tanks_list_container}>
                    {
                    
                        this.props.area.tanks.sort((a, b) => {
                            const idA = parseInt(a.tankId);
                            const idB = parseInt(b.tankId);
                            return idA > idB ? 1 : -1; 
                        }).map((item, index) => {
                            return (<div key={index} className={styles.tank_view_container} onClick={() => this.selectTank(item)}>
                                        <TankListView item={item}/>
                                    </div>);
                        })
                    }
                </div>
            </div>
        );
    }
}
